module.exports = __webpack_public_path__ + "img/icon-math-tab.431a206f.png";